import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import AccordionReact from 'devextreme-react/accordion';
import ToolbarAccordian, { Item as ItemAccordian } from 'devextreme-react/toolbar';
import { Button } from 'devextreme-react/button';
import { SelectBox } from 'devextreme-react/select-box';
import { TextBox } from 'devextreme-react/text-box';
import { TextArea } from 'devextreme-react';
import DateBox from 'devextreme-react/date-box';
import { DataGrid, Column, FilterRow, Paging, Scrolling, Sorting, ColumnChooser, ColumnChooserSearch, Toolbar as GridToolbar, Item as GridItem, Editing, Selection } from 'devextreme-react/data-grid';
import { alert } from 'devextreme/ui/dialog';
import * as PermissionsConstants from '../../const/constants';
import './wmmodulestyle.css';

// Mock data for available items (inventory)
const mockAvailableItems = [
    { id: 1, itemcode: 'ITEM-001', description1: 'Item Description 1', availableInventory: 100, lotcode: 'LOT-001' },
    { id: 2, itemcode: 'ITEM-002', description1: 'Item Description 2', availableInventory: 50, lotcode: 'LOT-002' },
    { id: 3, itemcode: 'ITEM-003', description1: 'Item Description 3', availableInventory: 75, lotcode: 'LOT-003' },
    { id: 4, itemcode: 'ITEM-004', description1: 'Item Description 4', availableInventory: 200, lotcode: 'LOT-004' },
    { id: 5, itemcode: 'ITEM-005', description1: 'Item Description 5', availableInventory: 30, lotcode: 'LOT-005' },
];

// Mock data for ordered items (starts empty)
const mockOrderedItems = [];

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

const MockupV3 = (props) => {
    const [selectedTopTabIndex, setSelectedTopTabIndex] = useState(0);
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [isFormSaved, setIsFormSaved] = useState(false);

    // Form state
    const [transactionDate, setTransactionDate] = useState(new Date());
    const [transactionNumber, setTransactionNumber] = useState('');
    const [profileData, setProfileData] = useState(null);
    const [customerData, setCustomerData] = useState(null);
    const [consigneeData, setConsigneeData] = useState(null);
    const [shipperData, setShipperData] = useState(null);
    const [carrierData, setCarrierData] = useState(null);
    const [shipperBolNumber, setShipperBolNumber] = useState('');
    const [reference, setReference] = useState('');
    const [receivingShippingDate, setReceivingShippingDate] = useState(null);
    const [comment, setComment] = useState('');
    const [consigneeInfo, setConsigneeInfo] = useState('');
    const [freightChargeType, setFreightChargeType] = useState('N');
    const [salesOrderNo, setSalesOrderNo] = useState('');

    // Grid state
    const [availableItems, setAvailableItems] = useState(mockAvailableItems);
    const [orderedItems, setOrderedItems] = useState(mockOrderedItems);
    const [selectedAvailableItems, setSelectedAvailableItems] = useState([]);

    // Mock data sources
    const mockProfileDataSource = [
        { code: 'PROF-001', id: 1 },
        { code: 'PROF-002', id: 2 },
        { code: 'PROF-003', id: 3 },
    ];
    const mockCustomerDataSource = [
        { identityId: 'CUST-001', id: 1 },
        { identityId: 'CUST-002', id: 2 },
        { identityId: 'CUST-003', id: 3 },
    ];
    const mockConsigneeDataSource = [
        { identityId: 'CONS-001', id: 1 },
        { identityId: 'CONS-002', id: 2 },
        { identityId: 'CONS-003', id: 3 },
    ];
    const mockShipperDataSource = [
        { identityId: 'SHIP-001', id: 1 },
        { identityId: 'SHIP-002', id: 2 },
        { identityId: 'SHIP-003', id: 3 },
    ];
    const mockCarrierDataSource = [
        { identityId: 'CARR-001', id: 1 },
        { identityId: 'CARR-002', id: 2 },
        { identityId: 'CARR-003', id: 3 },
    ];
    const freightChargeTypeOptions = [
        { Name: "None", ID: "N" },
        { Name: "Prepaid", ID: "P" },
        { Name: "Collect", ID: "C" },
        { Name: "Bill Third Party", ID: "B" }
    ];

    // Top tabs configuration (Receipt, Shipment, Adjustment)
    const topTabs = [
        {
            id: 1,
            label: "Receipt",
            permission: PermissionsConstants.TransactionReceipt,
        },
        {
            id: 2,
            label: "Shipment",
            permission: PermissionsConstants.TransactionShipment,
        },
        {
            id: 3,
            label: "Adjustment",
            permission: PermissionsConstants.TransactionAdjustment,
        },
    ];

    const onTopTabSelectionChanged = useCallback((e) => {
        if (e.fullName === 'selectedIndex') {
            setSelectedTopTabIndex(e.value);
        }
    }, []);

    const selectionChanged = useCallback((e) => {
        let newItems = [...selectedItems];
        e.removedItems.forEach((item) => {
            const index = newItems.indexOf(item);
            if (index >= 0) {
                newItems.splice(index, 1);
            }
        });
        if (e.addedItems.length) {
            newItems = [...newItems, ...e.addedItems];
        }
        // Allow accordion to be closed (empty array is allowed)
        setSelectedItems(newItems);
    }, [selectedItems]);

    const handleSave = () => {
        console.log('Save clicked');
        setIsFormSaved(true);
        // Close accordion after save
        setSelectedItems([]);
        // Show success alert
        alert("Transaction created successfully. You can add details in details section", "Success");
    };

    const handleBack = () => {
        console.log('Back clicked');
    };

    const handleAddToOrder = () => {
        if (selectedAvailableItems.length === 0) {
            return;
        }

        const newOrderedItems = selectedAvailableItems.map(item => {
            const availableItem = availableItems.find(ai => ai.id === item.id);
            return {
                ...availableItem,
                orderedQuantity: 0,
                originalAvailableInventory: availableItem.availableInventory, // Store original for calculation
                remainingInventory: availableItem.availableInventory
            };
        });

        setOrderedItems([...orderedItems, ...newOrderedItems]);
        setSelectedAvailableItems([]);
    };

    const handleRemoveFromOrder = (itemId) => {
        const itemToRemove = orderedItems.find(item => item.id === itemId);
        setOrderedItems(orderedItems.filter(item => item.id !== itemId));

        // Restore the available inventory when item is removed from order
        if (itemToRemove) {
            const originalAvailable = itemToRemove.originalAvailableInventory || itemToRemove.availableInventory;
            const remainingOrderedForItem = orderedItems
                .filter(item => item.id === itemId && item.id !== itemToRemove.id)
                .reduce((sum, item) => sum + (item.orderedQuantity || 0), 0);

            setAvailableItems(prevItems =>
                prevItems.map(item => {
                    if (item.id === itemId) {
                        return {
                            ...item,
                            availableInventory: Math.max(0, originalAvailable - remainingOrderedForItem)
                        };
                    }
                    return item;
                })
            );
        }
    };


    const handleOrderedQuantityChange = (itemId, newQuantity) => {
        const orderedQty = Math.max(0, newQuantity || 0);

        // Update ordered items
        const updatedOrderedItems = orderedItems.map(item => {
            if (item.id === itemId) {
                const originalAvailable = item.originalAvailableInventory || item.availableInventory;
                const orderedQty = Math.max(0, Math.min(newQuantity || 0, originalAvailable));
                return {
                    ...item,
                    orderedQuantity: orderedQty,
                    remainingInventory: originalAvailable - orderedQty
                };
            }
            return item;
        });
        setOrderedItems(updatedOrderedItems);

        // Update available items - calculate net available based on all ordered quantities for this item
        const orderedItem = updatedOrderedItems.find(item => item.id === itemId);
        if (orderedItem) {
            const totalOrderedForItem = updatedOrderedItems
                .filter(item => item.id === itemId)
                .reduce((sum, item) => sum + (item.orderedQuantity || 0), 0);

            const originalAvailable = orderedItem.originalAvailableInventory || orderedItem.availableInventory;
            const netAvailable = originalAvailable - totalOrderedForItem;

            setAvailableItems(prevItems =>
                prevItems.map(item => {
                    if (item.id === itemId) {
                        return {
                            ...item,
                            availableInventory: Math.max(0, netAvailable)
                        };
                    }
                    return item;
                })
            );
        }
    };

    const handleAvailableItemSelection = (e) => {
        // For single selection, convert to array format for compatibility
        const selectedData = e.selectedRowsData || [];
        setSelectedAvailableItems(selectedData);
    };

    const getCreateTitle = () => {
        const currentTab = topTabs[selectedTopTabIndex];
        if (currentTab?.permission === PermissionsConstants.TransactionReceipt) {
            return "Create New Receipt";
        } else if (currentTab?.permission === PermissionsConstants.TransactionAdjustment) {
            return "Create New Adjustment";
        } else {
            return "Create New Shipment";
        }
    };

    return (
        <div style={{ height: 'calc(100vh - 67px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            {/* Top Tab Panel - Receipt, Shipment, Adjustment */}
            <TabPanel
                key={selectedTopTabIndex}
                onOptionChanged={onTopTabSelectionChanged}
                selectedIndex={selectedTopTabIndex}
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}
            >
                {topTabs.map((tab, i) => (
                    <TabItem key={i} title={tab.label}>
                        <div className="row" style={{ flex: 1, minHeight: 0, height: '100%', display: 'flex', flexDirection: 'column', margin: 0, overflow: 'hidden' }}>
                            <div className="col-md-12 main-page" style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: 0 }}>
                                {/* Accordion Section - Form Fields Only */}
                                <div id="accordion" style={{ flex: '0 0 auto', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                    <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
                                        <AccordionReact
                                            dataSource={searchpanel}
                                            collapsible={true}
                                            multiple={false}
                                            animationDuration={300}
                                            selectedItems={selectedItems}
                                            onSelectionChanged={selectionChanged}
                                            id="accordion-container"
                                            defaultSelectedItems={[searchpanel[0]]}
                                            itemTitleRender={() => (
                                                <ToolbarAccordian className="accordian-toolbar">
                                                    <ItemAccordian location="before">
                                                        <div className="title">
                                                            <h6
                                                                style={{
                                                                    color: window._env_?.Color2 || '#333'
                                                                }}
                                                            >
                                                                {getCreateTitle()}
                                                            </h6>
                                                        </div>
                                                    </ItemAccordian>
                                                    <ItemAccordian location="after">
                                                        <Button
                                                            className="accordianButton"
                                                            text="Save"
                                                            onClick={handleSave}
                                                            type="default"
                                                        />
                                                    </ItemAccordian>
                                                    <ItemAccordian location="after">
                                                        <Button
                                                            className="accordianButton"
                                                            onClick={handleBack}
                                                            text="Back"
                                                        />
                                                    </ItemAccordian>
                                                </ToolbarAccordian>
                                            )}
                                            itemRender={(itemProps) => (
                                                <div style={{ paddingBottom: '12px', overflowY: 'auto' }}>
                                                    {/* First Row */}
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <DateBox
                                                                stylingMode='outlined'
                                                                labelMode="static"
                                                                label="Transaction Date:"
                                                                type="date"
                                                                value={transactionDate}
                                                                onValueChanged={(e) => setTransactionDate(e.value)}
                                                                showClearButton={true}
                                                            />
                                                        </div>
                                                        <div className="col-md-3">
                                                            <TextBox
                                                                id="transactionNo"
                                                                disabled
                                                                stylingMode='outlined'
                                                                labelMode="static"
                                                                label="Transaction No:"
                                                                value={transactionNumber}
                                                            />
                                                        </div>
                                                        <div className="col-md-3 d-flex align-items-center">
                                                            <div className="col-md-11 auto-complete-selectbox">
                                                                <SelectBox
                                                                    dataSource={mockCarrierDataSource}
                                                                    value={carrierData}
                                                                    searchEnabled={true}
                                                                    searchMode="contains"
                                                                    onValueChanged={(e) => setCarrierData(e.value)}
                                                                    label="Carrier ID:"
                                                                    labelMode='static'
                                                                    stylingMode='outlined'
                                                                    displayExpr="identityId"
                                                                    valueExpr="id"
                                                                />
                                                            </div>
                                                            <Button
                                                                icon="search"
                                                                stylingMode="text"
                                                            />
                                                        </div>
                                                        <div className="col-md-3">
                                                            <TextBox
                                                                id="transaction-reference"
                                                                stylingMode='outlined'
                                                                labelMode="static"
                                                                label="P.O. No:"
                                                                value={reference}
                                                                onValueChanged={(e) => setReference(e.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Second Row */}
                                                    <div className="row accordianLastRow">
                                                        <div className="col-md-3 d-flex align-items-center">
                                                            <div className="col-md-11 auto-complete-selectbox">
                                                                <SelectBox
                                                                    dataSource={mockConsigneeDataSource}
                                                                    value={consigneeData}
                                                                    searchEnabled={true}
                                                                    searchMode="contains"
                                                                    onValueChanged={(e) => setConsigneeData(e.value)}
                                                                    label="Consignee ID:"
                                                                    labelMode='static'
                                                                    stylingMode='outlined'
                                                                    displayExpr="identityId"
                                                                    valueExpr="id"
                                                                />
                                                            </div>
                                                            <Button
                                                                icon="search"
                                                                stylingMode="text"
                                                            />
                                                        </div>
                                                        <div className="col-md-3 d-flex align-items-center">
                                                            <div className="col-md-11 auto-complete-selectbox">
                                                                <SelectBox
                                                                    dataSource={mockShipperDataSource}
                                                                    value={shipperData}
                                                                    searchEnabled={true}
                                                                    searchMode="contains"
                                                                    onValueChanged={(e) => setShipperData(e.value)}
                                                                    label="Shipper ID:"
                                                                    labelMode='static'
                                                                    stylingMode='outlined'
                                                                    displayExpr="identityId"
                                                                    valueExpr="id"
                                                                />
                                                            </div>
                                                            <Button
                                                                icon="search"
                                                                stylingMode="text"
                                                            />
                                                        </div>
                                                        <div className="col-md-3">
                                                            <TextBox
                                                                id="shipperBolNumber"
                                                                stylingMode='outlined'
                                                                labelMode="static"
                                                                label="Shipper BOL:"
                                                                value={shipperBolNumber}
                                                                onValueChanged={(e) => setShipperBolNumber(e.value)}
                                                            />
                                                        </div>
                                                        <div className="col-md-3">
                                                            <DateBox
                                                                stylingMode='outlined'
                                                                labelMode="static"
                                                                label="Receiving/Shipping Date:"
                                                                type="date"
                                                                value={receivingShippingDate}
                                                                onValueChanged={(e) => setReceivingShippingDate(e.value)}
                                                                showClearButton={true}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Third Row */}
                                                    <div className="row accordianLastRow">
                                                        <div className="col-md-3">
                                                            <TextArea
                                                                value={consigneeInfo}
                                                                label="Consignee Info"
                                                                labelMode='static'
                                                                stylingMode='outlined'
                                                                readOnly={true}
                                                            />
                                                        </div>
                                                        <div className="col-md-3">
                                                            <TextArea
                                                                value={comment}
                                                                onValueChanged={(e) => setComment(e.value)}
                                                                label="Comment"
                                                                labelMode='static'
                                                                stylingMode='outlined'
                                                            />
                                                        </div>
                                                        {topTabs[selectedTopTabIndex]?.permission === PermissionsConstants.TransactionShipment && (
                                                            <>
                                                                <div className="col-md-3">
                                                                    <div className="col-md-12 auto-complete-selectbox">
                                                                        <SelectBox
                                                                            items={freightChargeTypeOptions}
                                                                            searchMode="contains"
                                                                            label="Freight Charge Type:"
                                                                            labelMode='static'
                                                                            stylingMode='outlined'
                                                                            displayExpr="Name"
                                                                            valueExpr="ID"
                                                                            value={freightChargeType}
                                                                            onValueChanged={(e) => setFreightChargeType(e.value)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <TextBox
                                                                        id="salesOrderNo"
                                                                        stylingMode='outlined'
                                                                        labelMode="static"
                                                                        label="Sales Order No:"
                                                                        value={salesOrderNo}
                                                                        onValueChanged={(e) => setSalesOrderNo(e.value)}
                                                                    />
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        />
                                    </form>
                                </div>

                                {/* Grids Section - Outside Accordion with horizontal layout (70%/30%) */}
                                <div style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'row', gap: '15px', overflow: 'hidden', marginTop: '15px' }}>
                                    {/* Available Items Section - 70% width */}
                                    <div style={{ flex: '0 0 70%', width: '70%', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                        <DataGrid
                                            dataSource={availableItems}
                                            showBorders={true}
                                            hoverStateEnabled={true}
                                            allowColumnReordering={true}
                                            allowColumnResizing={true}
                                            className="availableItems-height2"
                                            columnAutoWidth={true}
                                            onSelectionChanged={handleAvailableItemSelection}
                                            height="100%"
                                        >
                                            <Selection mode="single" />
                                            <ColumnChooser enabled={true}>
                                                <ColumnChooserSearch enabled={true} />
                                            </ColumnChooser>
                                            <FilterRow visible={true} />
                                            <Scrolling mode="standard" showScrollbar="auto" />
                                            <Sorting mode="multiple" />
                                            <Paging defaultPageSize={50} />
                                            <GridToolbar>
                                                <GridItem location="before">
                                                    <h6 style={{ margin: 0, color: window._env_?.Color2 || '#333' }}>Available Items</h6>
                                                </GridItem>
                                                <GridItem location="after">
                                                    <Button
                                                        text="Add to Order"
                                                        type="default"
                                                        onClick={handleAddToOrder}
                                                        disabled={selectedAvailableItems.length === 0}
                                                    />
                                                </GridItem>
                                                <GridItem name="exportButton" />
                                                <GridItem name="columnChooserButton" />
                                            </GridToolbar>
                                            <Column dataField="itemcode" caption="Item Code" allowEditing={false} />
                                            <Column dataField="description1" caption="Item Description" allowEditing={false} />
                                            <Column dataField="availableInventory" caption="Net Available" dataType="number" allowEditing={false} />
                                            <Column dataField="lotcode" caption="Lot" allowEditing={false} />
                                        </DataGrid>
                                    </div>

                                    {/* Ordered Items Section - 30% width */}
                                    <div style={{ flex: '0 0 30%', width: '30%', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                        <DataGrid
                                            dataSource={orderedItems}
                                            showBorders={true}
                                            hoverStateEnabled={true}
                                            allowColumnReordering={true}
                                            allowColumnResizing={true}
                                            columnAutoWidth={true}
                                            className="availableItems-height2"
                                            height="100%"
                                        >
                                            <Editing
                                                mode="cell"
                                                allowUpdating={true}
                                            />
                                            <ColumnChooser enabled={true}>
                                                <ColumnChooserSearch enabled={true} />
                                            </ColumnChooser>
                                            <FilterRow visible={false} />
                                            <Scrolling mode="standard" showScrollbar="auto" />
                                            <Sorting mode="multiple" />
                                            <Paging defaultPageSize={50} />
                                            <GridToolbar>
                                                <GridItem location="before">
                                                    <h6 style={{ margin: 0, color: window._env_?.Color2 || '#333' }}>Ordered Items</h6>
                                                </GridItem>
                                                <GridItem name="exportButton" />
                                                <GridItem name="columnChooserButton" />
                                            </GridToolbar>
                                            <Column dataField="itemcode" caption="Item Code" allowEditing={false} />
                                            <Column dataField="description1" caption="Item Description" allowEditing={false} />
                                            <Column
                                                dataField="orderedQuantity"
                                                caption="Ordered Quantity"
                                                dataType="number"
                                                allowEditing={true}
                                                setCellValue={(rowData, value) => {
                                                    handleOrderedQuantityChange(rowData.id, value);
                                                }}
                                            />
                                            <Column
                                                dataField="lotcode"
                                                caption="Lot"
                                                allowEditing={false}
                                            />
                                            <Column
                                                caption=""
                                                width={80}
                                                allowEditing={false}
                                                cellRender={(data) => {
                                                    return (
                                                        <div>x</div>
                                                     );
                                                }}
                                            />
                                        </DataGrid>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabItem>
                ))}
            </TabPanel>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(MockupV3);

